export const PERMISSION_SCOPES = {
  CUSTOM: 'CUSTOM',
  DR: 'DR',
  GLOBAL: 'GLOBAL',
  IDR: 'IDR',
  SELF: 'SELF',
};

export const PERMISSION_ACTIONS = {
  DELETE: 'delete',
  EDIT: 'edit',
  MANAGE: 'manage',
  VIEW: 'view',
};

export const PERMISSION_CODES = {
  ABSENCE_REQUESTS_MANAGE: 'absence.requests.manage',
  ABSENCE_SETTINGS_MANAGE: 'absence.manage',
  ABSENCE_VIEW: 'absence.view',

  ANNOUNCEMENTS_MANAGE: 'announcements.manage',
  ANNOUNCEMENTS_VIEW: 'announcements.view',

  ATTRIBUTES_MANAGE: 'attributes.manage',
  ATTRIBUTES_VIEW: 'attributes.view',

  CYCLES_MANAGE: 'cycles.manage',
  CYCLES_VIEW: 'cycles.view',

  DEPARTMENTS_DELETE: 'departments.delete',
  DEPARTMENTS_USERS_MANAGE: 'departments.users.manage',
  DEPARTMENTS_EDIT: 'departments.edit',
  DEPARTMENTS_VIEW: 'departments.view',

  JOB_TITLES_MANAGE: 'job_titles.manage',
  JOB_TITLES_USERS_MANAGE: 'job_titles.users.manage',
  JOB_TITLES_VIEW: 'job_titles.view',

  SUCCESSION_MANAGE: 'succession.manage',

  LEARNING_DELETE: 'learning.delete',
  LEARNING_MANAGE_USERS: 'learning.users.manage',
  LEARNING_EDIT: 'learning.edit',
  LEARNING_VIEW: 'learning.view',

  LEVELING_DELETE: 'leveling.delete',
  LEVELING_MANAGE_USERS: 'leveling.users.manage',
  LEVELING_EDIT: 'leveling.edit',
  LEVELING_VIEW: 'leveling.view',

  ONE_ON_ONE_DELETE: 'one_on_one.delete',
  ONE_ON_ONE_EDIT: 'one_on_one.edit',
  ONE_ON_ONE_COMMENTS_MANAGE: 'one_on_one.comments.manage',
  ONE_ON_ONE_VIEW: 'one_on_one.view',

  PLANS_DELETE: 'plans.delete',
  PLANS_EDIT: 'plans.edit',
  PLANS_COMMENTS_DELETE: 'plans.comments.delete',
  PLANS_VIEW: 'plans.view',

  PROFILES_DELETE: 'profiles.delete',
  PROFILES_EDIT: 'profiles.edit',
  PROFILES_CREATE: 'profiles.create',
  PROFILES_ROLES_MANAGE: 'profiles.roles.manage',
  PROFILES_SENSITIVE_DATA_VIEW: 'profiles.sensitive.view',
  PROFILES_DOCUMENTS_VIEW: 'profiles.documents.view',
  PROFILES_DOCUMENTS_MANAGE: 'profiles.documents.manage',
  PROFILES_VIEW: 'profiles.view',

  RECRUITMENT_DELETE: 'recruitment.delete',
  RECRUITMENT_EDIT: 'recruitment.edit',
  RECRUITMENT_VIEW: 'recruitment.view',

  REPORTS_SUMMARY_MANAGE: 'reports.summary.manage',
  REPORTS_ATTRIBUTE_VIEW: 'reports.attributes.view',
  REPORTS_HEADCOUNT_VIEW: 'reports.headcount.view',
  REPORTS_ABSENCE_VIEW: 'reports.absence.view',
  REPORTS_OVERVIEW_VIEW: 'reports.overview.view',
  REPORTS_COMPETENCE_MAP_VIEW: 'reports.competence.view',
  REPORTS_SKILLS_MATRIX_VIEW: 'reports.skills.view',
  REPORTS_GENERAL_MOOD_VIEW: 'reports.mood.view',
  REPORTS_COMPARE_VIEW: 'reports.compare.view',

  SETTINGS_DEMO_DATA_MANAGE: 'settings.demo_data.manage',
  SETTINGS_DOCUMENTS_MANAGE: 'settings.user_documents.manage',
  SETTINGS_PERSON_FIELDS_INFO_MANAGE: 'settings.person_info.manage',
  SETTINGS_FEATURES_MANAGE: 'settings.features.manage',
  SETTINGS_PERMISSIONS_MANAGE: 'settings.permissions.manage',
  SETTINGS_SLACK_INTEGRATION_MANAGE: 'settings.slack_integration.manage',
  SETTINGS_SUBSCRIPTION_MANAGE: 'settings.subscriptions.manage',

  SURVEYS_MANAGE_ALL: 'surveys.manage.all',
  SURVEYS_MANAGE_CREATED: 'surveys.manage.created',
  SURVEYS_VIEW_ALL: 'surveys.view.all',
  SURVEYS_VIEW_CREATED: 'surveys.view.created',

  TAGS_USERS_MANAGE: 'tags.users.manage',
  TAGS_MANAGE: 'tags.manage',
  TAGS_VIEW: 'tags.view',
};

export const PERMISSIONS_WITH_GLOBAL_SCOPE = [
  PERMISSION_CODES.ABSENCE_VIEW,
  PERMISSION_CODES.ABSENCE_SETTINGS_MANAGE,
  PERMISSION_CODES.ANNOUNCEMENTS_MANAGE,
  PERMISSION_CODES.ANNOUNCEMENTS_VIEW,
  PERMISSION_CODES.ASSIGNMENTS_VIEW,
  PERMISSION_CODES.ATTRIBUTES_MANAGE,
  PERMISSION_CODES.ATTRIBUTES_VIEW,
  PERMISSION_CODES.CYCLES_VIEW,
  PERMISSION_CODES.CYCLES_MANAGE,
  PERMISSION_CODES.DEPARTMENTS_VIEW,
  PERMISSION_CODES.DEPARTMENTS_EDIT,
  PERMISSION_CODES.DEPARTMENTS_DELETE,
  PERMISSION_CODES.JOB_TITLES_MANAGE,
  PERMISSION_CODES.JOB_TITLES_VIEW,
  PERMISSION_CODES.LEARNING_DELETE,
  PERMISSION_CODES.LEARNING_EDIT,
  PERMISSION_CODES.LEARNING_VIEW,
  PERMISSION_CODES.LEVELING_DELETE,
  PERMISSION_CODES.LEVELING_EDIT,
  PERMISSION_CODES.LEVELING_VIEW,
  PERMISSION_CODES.RECRUITMENT_DELETE,
  PERMISSION_CODES.RECRUITMENT_EDIT,
  PERMISSION_CODES.RECRUITMENT_VIEW,
  PERMISSION_CODES.PROFILES_CREATE,
  PERMISSION_CODES.REPORTS_SUMMARY_MANAGE,
  PERMISSION_CODES.REPORTS_ABSENCE_VIEW,
  PERMISSION_CODES.REPORTS_ATTRIBUTE_VIEW,
  PERMISSION_CODES.REPORTS_HEADCOUNT_VIEW,
  PERMISSION_CODES.REPORTS_OVERVIEW_VIEW,
  PERMISSION_CODES.SETTINGS_DEMO_DATA_MANAGE,
  PERMISSION_CODES.SETTINGS_DOCUMENTS_MANAGE,
  PERMISSION_CODES.SETTINGS_FEATURES_MANAGE,
  PERMISSION_CODES.SETTINGS_PERMISSIONS_MANAGE,
  PERMISSION_CODES.SETTINGS_PERSON_FIELDS_INFO_MANAGE,
  PERMISSION_CODES.SETTINGS_SLACK_INTEGRATION_MANAGE,
  PERMISSION_CODES.SETTINGS_SUBSCRIPTION_MANAGE,
  PERMISSION_CODES.SUCCESSION_MANAGE,
  PERMISSION_CODES.SURVEYS_VIEW_ALL,
  PERMISSION_CODES.SURVEYS_VIEW_CREATED,
  PERMISSION_CODES.SURVEYS_MANAGE_ALL,
  PERMISSION_CODES.SURVEYS_MANAGE_CREATED,
  PERMISSION_CODES.TAGS_MANAGE,
  PERMISSION_CODES.TAGS_VIEW,
];

export const DISABLED_PERMISSION_CODES = [
  PERMISSION_CODES.PROFILES_DELETE,
  PERMISSION_CODES.ANNOUNCEMENTS_VIEW,
];

export const PARTIALLY_DISABLED_PERMISSION_CODES = [
  {
    code: PERMISSION_CODES.PROFILES_ROLES_MANAGE,
    scopes: [PERMISSION_SCOPES.SELF],
  },
];

export const NESTED_VIEW_PERMISSION_PAIRS = [
  {
    view: PERMISSION_CODES.PROFILES_DOCUMENTS_VIEW,
    prefix: 'profiles.documents.',
  },
];

export const REVIEW_GROUP = 'reviews';

export const REVIEW_ROOT_VIEW_PERMISSION_CODES = [
  PERMISSION_CODES.SURVEYS_VIEW_ALL,
  PERMISSION_CODES.SURVEYS_VIEW_CREATED,
];

export const REVIEW_ROOT_ALL_POSSIBLE_PERMISSION_CODES = [
  PERMISSION_CODES.SURVEYS_VIEW_ALL,
  PERMISSION_CODES.SURVEYS_MANAGE_ALL,
];

export const REVIEW_ROOT_CREATED_POSSIBLE_PERMISSION_CODES = [
  PERMISSION_CODES.SURVEYS_VIEW_CREATED,
  PERMISSION_CODES.SURVEYS_MANAGE_CREATED,
];
